import FeedbackPage from '@/components/FeedbackPage'
import { SparklesIcon } from '@heroicons/react/24/outline'

export default function NutritionIntroPage() {
  return (
    <FeedbackPage
      icon={<SparklesIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.nutritionIntro.heading"
      descriptionKey="pages.onboarding.nutritionIntro.description"
    />
  )
}
